import {CoilRequest} from './coil-request';

export class RatingsMassUpdate {

  refrigerantLines: number[];
  refrigerantInputs!: CoilRequest;
  hydronicCoolingLines: number[];
  hydronicCoolingInputs!: CoilRequest;
  steamLines: number[];
  steamInputs!: CoilRequest;
  hydronicHeatingLines: number[];
  hydronicHeatingInputs!: CoilRequest;
  electricHeatLines: number[];
  electricHeatInputs!: CoilRequest;
  isMetric!: boolean;
  externalStaticPressure!: number;
  altitude!: number;

  constructor() {
    this.refrigerantLines = [];
    this.hydronicCoolingLines = [];
    this.steamLines = [];
    this.hydronicHeatingLines = [];
    this.electricHeatLines = [];
  }

}
